import {NgModule} from '@angular/core';
import {CommonModule} from "@angular/common";

import {GlmModalComponent} from './glm-modal.component';
import {GlmModalService} from "./glm-modal.service";
// import {AngularDraggableModule} from "angular2-draggable";
import {GLMMaterialDesignModule} from "../material-design/material-design.module";

@NgModule({
    imports: [CommonModule, 
        // AngularDraggableModule, 
        GLMMaterialDesignModule],
    exports: [GlmModalComponent],
    declarations: [GlmModalComponent],
    providers: [GlmModalService],
})
export class GlmModalModule {
}
